import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { AmbarService } from "../../../services/AmbarService";
import CustomSwitch from "../../../components/CustomSwitch";
import Orders from "./Components/Orders";
import Prices from "./Components/Prices";
import PriceCandidates from "./Components/PriceCandidates";
import PriceGroupDecisionModal from "./Components/PriceGroupDecisionModal";
import { PriceGroupDecisionEnum } from "../../../models/common/Enums";
import { AmbarFindPriceRequest } from "../../../models/request/ambar/AmbarFindPriceRequest";
import { GetAmbarListResponse, GetAmbarListResponseAmbarExpectedIncomeOutcome, GetAmbarListResponseData } from "../../../models/response/ambar/GetAmbarListResponse";
import SeferUyeleri from "./Components/SeferUyeleri";
import { seferListesindeMi, seferUyeSatirlari, SeferUyeSatiri } from "../../../helpers/seferFiyat";

const AmbarFindPrice = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Nakliye > Toplu Fiyat Bulma"
    const dispatch = useDispatch();

    const [mainData, setMainData] = useState<GetAmbarListResponseData[]>([]);
    const [subData, setSubData] = useState<GetAmbarListResponseAmbarExpectedIncomeOutcome[]>([]);
    // Fiyat bulunamayan siparişler: "Fiyat Bulunamayan Siparişler" tablosunda gösterilir.
    const [noPriceData, setNoPriceData] = useState<GetAmbarListResponseData[]>([]);
    const [isIncome, setIsIncome] = useState(true);
    const [isOutcome, setIsOutcome] = useState(false);
    // Günlük Bölüm Grubu kararı: sunucu karar isterse pencere açılır; verilen karar kaydetmede de kullanılır.
    const [isDecisionShown, setIsDecisionShown] = useState(false);
    const [conflictRefNos, setConflictRefNos] = useState<string[]>([]);
    const [pendingAction, setPendingAction] = useState<'bul' | 'kaydet' | undefined>(undefined);
    const [groupDecision, setGroupDecision] = useState<string | undefined>(undefined);
    // Sefer Fiyat Bul: kutu kapaliyken daha once hesaplanmis (faturalanmamis) seferler atlanir.
    const [seferleriYenidenHesapla, setSeferleriYenidenHesapla] = useState(false);
    // Bul'da kullanilan deger kaydederken de gecerlidir.
    const [hesaplanmisSeferleriAtla, setHesaplanmisSeferleriAtla] = useState(true);
    // Seferden eklenen ve atlanan siparisler (ayri liste; secilmez).
    const [seferListesi, setSeferListesi] = useState<SeferUyeSatiri[]>([]);

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            var str = localStorage.getItem("SelectedIds");
            localStorage.removeItem("SelectedIds");

            if (str) {
                var ids: string[] = JSON.parse(str);

                if (ids && ids.length > 0) {
                    dispatch(storeActivityIndicator(true));

                    var response: GetAmbarListResponse = await AmbarService.getAmbarList(ids);

                    if (!response.isSuccess) {
                        toast.error(response.message)
                        return;
                    }

                    response.data = response.data.map(function (x) {
                        x.ambarExpectedIncomeOutcomes = x.ambarExpectedIncomeOutcomes.filter(x => !x.invoiceId);
                        return x;
                    })

                    setMainData(response.data);
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Onclick olay nesnesini ilk parametre olarak verdiği için karar ayrı fonksiyonda taşınır.
    const findPrice = () => hesaplaFiyat();

    const hesaplaFiyat = async (decision?: string) => {
        var selectedItems = mainData.filter(x => x.isSelected);

        if (selectedItems.length == 0) {
            toast.error("En az bir sipariş seçiniz!");
            return
        }

        try {
            dispatch(storeActivityIndicator(true));

            var atla = !seferleriYenidenHesapla;

            var obj: AmbarFindPriceRequest = {
                isIncome: isIncome,
                isTemp: true,
                groupDecision: decision,
                hesaplanmisSeferleriAtla: atla,
                details: selectedItems.map(function (x) {
                    return { ambarId: x.ambarId }
                })
            }

            var response: GetAmbarListResponse = await AmbarService.ambarFindPrice(obj);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false));
                return;
            }

            // Günlük Bölüm Grubu: aynı gün aynı gruptaki önceki siparişler var; kullanıcı karar verene kadar fiyat hesaplanmaz.
            if (kararGerekli(response, 'bul')) {
                dispatch(storeActivityIndicator(false));
                return;
            }

            setGroupDecision(decision);
            setHesaplanmisSeferleriAtla(atla);

            // Seferden eklenenler ve atlananlar ayri listede; secim/fiyat tablolarina girmez (seferden eklenenleri sunucu otomatik yazar).
            setSeferListesi(seferUyeSatirlari(response.data.filter(seferListesindeMi)));

            // "Diğerleriyle Birlikte": önceki siparişler de seçilmiş gibi listeye gelir. Seferden eklenenler gelmez.
            const yeniSiparisler = response.data.filter(x => !x.seferdenEklendi && !mainData.some(m => m.ambarId == x.ambarId));

            if (yeniSiparisler.length > 0) {
                setMainData([
                    ...mainData,
                    ...yeniSiparisler.map(x => ({ ...x, ambarExpectedIncomeOutcomes: x.ambarExpectedIncomeOutcomes.filter(r => !r.invoiceId), isSelected: true }))
                ]);
            }

            response.data = response.data.map(function (a) {
                // Fiyatı 0 olan anlaşmalar da listelenir; tutarı sıfır olan hizmet de beklenen gelir/gidere eklenebilmelidir.
                a.ambarExpectedIncomeOutcomes = a.ambarExpectedIncomeOutcomes.filter(x => x.agreementSchemeId).map(function (x) {
                    x.uniqueId = x.ambarId + "-" + x.agreementSchemeId;
                    x.refNo = a.refNo;
                    return x;
                })

                return a;
            })

            // Fiyat bulunamayan siparişler listeden düşüyor; nedenleri aşağıdaki tabloda gösteriliyor.
            const fiyatsizlar = response.data.filter(x => !seferListesindeMi(x) && x.ambarExpectedIncomeOutcomes.length == 0);

            setNoPriceData(fiyatsizlar);

            if (fiyatsizlar.length > 0)
                toast.error(fiyatsizlar.length + " siparişe fiyat bulunamadı. Nedenleri aşağıdaki listede.", { duration: 8000 });

            response.data = response.data.filter(x => !seferListesindeMi(x) && x.ambarExpectedIncomeOutcomes.length > 0);

            setSubData(response.data.flatMap(x => x.ambarExpectedIncomeOutcomes));

            dispatch(storeActivityIndicator(false));
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    /**
     * Sunucu Günlük Bölüm Grubu kararı istediyse pencereyi açar ve true döner; hesap/kayıt yapılmaz.
     * Karar verilince aynı işlem (bul ya da kaydet) kararla tekrarlanır.
     */
    const kararGerekli = (response: GetAmbarListResponse, islem: 'bul' | 'kaydet') => {
        if (!response.data.some(x => x.priceGroupDecisionNeeded))
            return false;

        setConflictRefNos(response.data.filter(x => x.isPriceGroupConflict).map(x => x.refNo));
        setPendingAction(islem);
        setIsDecisionShown(true);

        return true;
    }

    const kararVerildi = (decision: string) => {
        const islem = pendingAction;

        setIsDecisionShown(false);
        setPendingAction(undefined);

        if (islem == 'bul')
            hesaplaFiyat(decision);
        else if (islem == 'kaydet')
            savePrice(decision);
    }

    const kararIptal = () => {
        setIsDecisionShown(false);
        setPendingAction(undefined);
    }

    const savePrice = async (decision?: string) => {
        var selectedItems = subData.filter(x => x.isSelected);

        if (selectedItems.length == 0) {
            toast.error("En az bir fiyat seçiniz!");
            return
        }

        try {
            dispatch(storeActivityIndicator(true));

            var obj: AmbarFindPriceRequest = {
                isIncome: isIncome,
                isTemp: false,
                // Fiyat bulunurken verilen karar kaydederken de geçerlidir.
                groupDecision: decision ?? groupDecision,
                hesaplanmisSeferleriAtla: hesaplanmisSeferleriAtla,
                details: selectedItems.map(function (x) {
                    return {
                        ambarId: x.ambarId,
                        agreementSchemeId: x.agreementSchemeId
                    }
                })
            }

            var response: GetAmbarListResponse = await AmbarService.ambarFindPrice(obj);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false));
                return;
            }

            if (kararGerekli(response, 'kaydet')) {
                dispatch(storeActivityIndicator(false));
                return;
            }

            dispatch(storeActivityIndicator(false));

            toast.success("İşlem başarılı.");
            navigate('/ambar/list');
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className="row">
                                <div className="col-md-4">
                                    <Box flexDirection={"row"}>
                                        <Box flex={1} justifyContent="center">
                                            <CustomSwitch
                                                labelText="Gelir"
                                                isLabelRequired
                                                isActive={isIncome}
                                                setIsActive={() => {
                                                    setIsIncome(!isIncome);
                                                    setIsOutcome(!isOutcome);
                                                }}
                                            />
                                        </Box>
                                        <Box flex={1} justifyContent="center">
                                            <CustomSwitch
                                                labelText="Gider"
                                                isLabelRequired
                                                isActive={isOutcome}
                                                setIsActive={() => {
                                                    setIsIncome(!isIncome);
                                                    setIsOutcome(!isOutcome);
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <Orders
                        data={mainData}
                        findPrice={findPrice}
                        setData={setMainData}
                        seferleriYenidenHesapla={seferleriYenidenHesapla}
                        setSeferleriYenidenHesapla={setSeferleriYenidenHesapla}
                    />

                    {
                        subData.length > 0 && (
                            <Prices
                                data={subData}
                                setData={setSubData}
                            />
                        )
                    }

                    {
                        seferListesi.length > 0 && (
                            <KTCard className="ebbe-card mt-10">
                                <KTCardBody>
                                    <h4 className="mb-2 text-black">Sefer ile Hesaplanan / Atlanan Siparişler</h4>

                                    <div className="text-muted fw-semibold mb-8" style={{ fontSize: 13 }}>
                                        Seferden eklenen siparişlerin fiyatı, seferdeki seçili siparişle birlikte Kaydet'te otomatik yazılır.
                                        Atlanan siparişlere fiyat yazılmaz.
                                    </div>

                                    <SeferUyeleri satirlar={seferListesi} />
                                </KTCardBody>
                            </KTCard>
                        )
                    }

                    <PriceCandidates data={noPriceData} />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate('/ambar/list')}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={() => savePrice()}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>

            <PriceGroupDecisionModal
                isShown={isDecisionShown}
                refNos={conflictRefNos}
                onSeparate={() => kararVerildi(PriceGroupDecisionEnum.SEPARATE)}
                onTogether={() => kararVerildi(PriceGroupDecisionEnum.TOGETHER)}
                onClose={kararIptal}
            />
        </React.Fragment>
    )
}

export default AmbarFindPrice;